export const rsa2048PublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0YC6XE12pbMznuNc3Eyx
/5ZDbEig0GwbzoGWl+/KsgUcP1qLaDfesZqNJ8+Y4QXzSREpECkolLvc76wk4Eat
+VKgGhBcF0lD/CpjRPGvCK7PKvmbdJNpCadXKOUOAd3ItZyt97t0aE6px9BIzcbn
g6ospk4Cx4sVI9h5SIEzAtVK8oVoy/4LxmaBsV2SabTVKUSgnJt4RFtcq64CIMiw
DT9kyf43swOo34TBbTKjk90YeTV6FoaPKfEG9FHjaUAErgTUznP8c+kUr5o4iY4J
rDutzgkrbNaxDVM3CucYtdcVV4SGASYL+R6HAacC7pvcuhiYvzJwvKdzu0zukoYt
6QIDAQAB
-----END PUBLIC KEY-----`;
